import { User } from "@typings/user"

export async function getUser(authToken: string): Promise<User> {
  const response = await fetch(`${import.meta.env.VITE_API}/data/getUserInfo`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  })

  if (!response.status) throw new Error(response.statusText)

  const user: User = await response.json()

  if (typeof user?.balance !== "undefined") {
    localStorage.setItem(
      `${user.id}_statistics`,
      JSON.stringify(user.statistics)
    )
    localStorage.setItem(
      `${user.id}_customs`,
      JSON.stringify({
        background: user.customs.background,
        cards: user.customs.cards,
      })
    )

    if (user.lang) localStorage.setItem(`${user.id}_lang`, user.lang)

    window.dispatchEvent(new Event("storage"))
  }

  return user
}
